import React from "react";
import SearchDropdown from "./SearchDropdown";
import SuggestionsDropdown from "./SuggestionsDropdown";

interface IProps {
  type: "search" | "suggestion" | "recentSearches";
  items: string[];
  onSelect: (value: string) => void;
  selectedIndex: number;
  setSelectedIndex: (index: number | ((prev: number) => number)) => void;
}

const KeywordsDropdown: React.FC<IProps> = ({
  type,
  items,
  onSelect,
  selectedIndex,
  setSelectedIndex,
}) => {
  return (
    <>
      {type === "search" || type === "recentSearches" ? (
        <SearchDropdown
          items={items}
          onSelect={onSelect}
          isRecentSearch={type === "recentSearches"}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
      ) : (
        <SuggestionsDropdown items={items} onSelect={onSelect} />
      )}
    </>
  );
};

export default KeywordsDropdown;
